import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Delete } from "@material-ui/icons";
import { FormatColorFill } from "@material-ui/icons";
import { InsertPhoto } from "@material-ui/icons";
import ChromePicker from "react-color";
import CircularProgress from "@material-ui/core/CircularProgress";

class ArticuloStockItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedIndexColorImagen: 1,
      displayColorPicker: false,
      color: {
        hex: "#fff",
      },
      file: undefined,
      valid: true,
      selectedTalles: [],
      update: false,
    };
  }

  fileRef = undefined;

  UNSAFE_componentWillReceiveProps(props) {
    if (props.talle !== undefined && this.state.update == false) {
      this.setState({
        update: true,
      });
    }
  }

  onChangeTalleStock = (nombre, event) => {
    let selectedTalle = { talleSelected: nombre, cantidad: event.target.value };
    var esNumero = !isNaN(selectedTalle.cantidad);
    if (esNumero) {
      this.setState({
        selectedTalles: [...this.state.selectedTalles, selectedTalle],
      });
    }
  };

  onChangeCantidad = (event, indexTalle, indexStock) => {
    this.props.onChangeCantidad(event, indexTalle, indexStock);
  };

  handleChangeColorImagen = (event) => {
    this.props.handleArticuloStockTipo(event.target.value, this.props.index); // llamo al handler del container
  };

  setSelectedTypeTalles = () => {
    this.props.handleSelectedTypeTalles(this.state.selectedIndexColorImagen);
  };

  handleDeleteRow = () => {
    this.props.handleStockDelete(this.props.index);
  };

  handleClickColorPicker = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleCloseColorPicker = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChangeColorSelector = (color) => {
    this.setState({ color: color.hex });
  };

  handleImageOpener = () => {
    this.fileRef.click();
  };

  onChangeFile = (e) => {
    let file = URL.createObjectURL(e.target.files[0]);
    e.target.value = null;
    this.setState({ file: file });
  };

  render() {
    return (
      <div>
        <Row style={{ backgroundColor: "white" }}>
          <Col md={6} className="colorSelector">
            {/*VERIFICO SI HAY ERROR O NO */}
            {this.props.errorDescription.errorColorImagen !== undefined ||
            this.props.errorDescription.errorColorImagen === "" ? (
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Delete onClick={this.handleDeleteRow} style={{ cursor: "pointer" }} />
                    </InputAdornment>
                  ),
                }}
                id="tipoArticulo"
                select
                error
                helperText={this.props.errorDescription.errorColorImagen}
                label="Color"
                value={this.props.articulo.stock[this.props.index].idTipo}
                onChange={this.handleChangeColorImagen}
                style={{ width: "100%" }}
                margin="normal"
              >
                <MenuItem key={1} value={1}>
                  Color
                </MenuItem>
                <MenuItem key={2} value={2}>
                  Imagen
                </MenuItem>
              </TextField>
            ) : (
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Delete onClick={this.handleDeleteRow} style={{ cursor: "pointer" }} />
                    </InputAdornment>
                  ),
                }}
                id="tipoArticulo"
                select
                label="Color"
                value={this.props.articulo.stock[this.props.index].idTipo}
                onChange={this.handleChangeColorImagen}
                style={{ width: "100%" }}
                margin="normal"
              >
                <MenuItem key={1} value={1}>
                  Color
                </MenuItem>
                <MenuItem key={2} value={2}>
                  Imagen
                </MenuItem>
              </TextField>
            )}

            {/* color display */}
            {this.props.articulo.stock[this.props.index].idTipo == "1" && (
              <div style={{ display: "flex" }}>
                <div
                  className="picker first"
                  style={{ backgroundColor: this.props.articulo.stock[this.props.index].color }}
                >
                  {" "}
                </div>
                <FormatColorFill
                  fontSize={"large"}
                  className="picker"
                  onClick={this.handleClickColorPicker}
                />
              </div>
            )}

            {/* image display */}
            {this.props.articulo.stock[this.props.index].idTipo == "2" && (
              <div style={{ display: "flex" }}>
                {this.props.articulo.stock[this.props.index].imagen !== undefined ? (
                  this.props.articulo.stock[this.props.index].imagen !== "" ? (
                    <img
                      src={this.props.articulo.stock[this.props.index].imagen}
                      className="picker first"
                    />
                  ) : (
                    <div className="picker first"></div>
                  )
                ) : (
                  <div className="loaderContainer">
                    <CircularProgress className="circularProgressLoader" />
                  </div>
                )}
                <InsertPhoto
                  className="picker"
                  fontSize={"large"}
                  onClick={this.handleImageOpener}
                  style={{ cursor: "pointer" }}
                />
              </div>
            )}
          </Col>

          {/* Input para cargar Imagen (si no se quiere permitir actualizar imagen hay que descomentar el disabled)*/}
          <input
            type="file"
            ref={(e) => {
              this.fileRef = e;
            }}
            style={{ display: "none" }}
            onChange={(e) => this.props.handleStockImagen(e, this.props.index)}
            accept="image/*"
            onClick={(event) => {
              event.target.value = null;
            }}
          />

          {/* Color Picker */}
          {this.state.displayColorPicker &&
          this.props.articulo.stock[this.props.index].idTipo == "1" ? (
            <div>
              <div onClick={this.handleCloseColorPicker} />
              <ChromePicker
                className="ColorPicker"
                color={this.props.articulo.stock[this.props.index].color}
                onChange={(e) => this.props.handleStockColor(e, this.props.index)}
              />
            </div>
          ) : null}

          {/* Talles */}
          <Col md={6}>
            <Row style={{ backgroundColor: "white" }}>
              {this.props.talle.map((c, i) => {
                return (
                  <Col key={i} md={2}>
                    {(i === 0 && this.props.errorDescription.errorNumeroStock !== undefined) ||
                    (i === 0 && this.props.errorDescription.errorNumeroStock === "") ? (
                      <TextField
                        type="number"
                        label={c.nombre} //las etiquetas de los talles
                        error
                        helperText={this.props.errorDescription.errorNumeroStock}
                        style={{ width: "100%" }}
                        margin="normal"
                        onChange={(e) => this.onChangeCantidad(e, i, this.props.index)}
                      />
                    ) : (
                      <TextField
                        type="number"
                        value={c.qty !== undefined ? c.qty : ""}
                        label={c.nombre} //las etiquetas de los talles
                        style={{ width: "100%" }}
                        margin="normal"
                        onChange={(e) => this.onChangeCantidad(e, i, this.props.index)}
                      />
                    )}
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

ArticuloStockItem.defaultProps = {
  talle: [],
  index: 0,
  handleDelete: (f) => f,
  handleSelectedTypeTalles: (f) => f,
};

ArticuloStockItem.propTypes = {
  talle: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleSelectedTypeTalles: PropTypes.func.isRequired,
};

export default ArticuloStockItem;
